import { gql } from '@apollo/client'

export const NEW_MESSAGE_SUBSCRIPTION = gql`
  subscription newMessage($myId: String!, $withUser: [String]) {
    newMessage(myId: $myId, withUser: $withUser) {
      _id
      cursor
      text
      createdAt
      sender
      attachments {
        url
        filetype
        filename
        filesize
        kind
      }
    }
  }
`
export const NEW_CHAT_SUBSCRIPTION = gql`
  subscription newChat {
    newChat {
      _id
      dateCreated
      requesterId
      requester {
        username
      }
    }
  }
`
export const NEW_CHAT_MESSAGE_SUBSCRIPTION = gql`
  subscription newChatMessage {
    chatHasNewMessage {
      chatId
    }
  }
`
